import RemoteCall from "../../../util/RemoteCall";

const remoteCall = new RemoteCall("/api/noAuth/hzwjw/user");

const decryptUserAsync = (param) => {
    return remoteCall.get("decryptUser", param);
};

export default {
    decryptUserAsync,
};
